<template>
  <div class="grid-fund-review">
    <filterBar
      @updateFilters="updateFilters(...arguments)"
      :client="selectedClient"
      :fiduciary="selectedFiduciary"
      :hideFilters="hideFilters"
      @updateProductFunds="updateProduct"
      :initialState="savedFilter"
    />
    <FundReviewPanelGrid
        :filters="currentFilters"
        @showToolTip="onShowTooltip"
        @hideToolTip="onHideTooltip"
    ></FundReviewPanelGrid>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FilterBar from '@/components/organisms/FilterBar';
import FundReviewPanelGrid from '@/components/organisms/FundReviewPanelGrid';
import { cloneDeep } from 'lodash';

export default {
  name: 'grid-fund-review',
  computed: {
    ...mapState({
      selectedFiduciary: (state) => state.user.fiduciary.id,
      selectedClient: (state) => state.grid.client.selected,
      selectedTab: (state) => state.grid.tab,
      savedFilter: (state) => cloneDeep(state.grid.savedFilter),
    }),
  },
  components: {
    FilterBar,
    FundReviewPanelGrid,
  },
  data() {
    return {
      currentFilters: {
        assets: [],
        categories: [],
        status: [],
        reviewStatus: [],
      },
      allStatusMode: false,
      hideFilters: {
        updates: true,
        dateRange: true,
      },
    };
  },
  methods: {
    updateFilters(filters, allStatus) {
      this.currentFilters.assets = filters.assets;
      this.currentFilters.categories = filters.categories;
      this.currentFilters.status = filters.status;
      this.currentFilters.reviewStatus = filters.reviewStatus;
      this.allStatusMode = allStatus;
    },
    updateProduct(product, productName, productCode) {
      this.$store.dispatch('setProduct', {
        code: productCode,
        listVisible: false,
        name: productName,
        selected: product,
      });
    },
    onShowTooltip(event, status, orientation, size) {
      this.$emit('showTooltip', event, status, orientation, size);
    },
    onHideTooltip(event) {
      this.$emit('hideTooltip', event);
    },
  },
};
</script>

<style lang="scss">
.grid-fund-review {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  @media screen and (max-height: 624px) {
    .single-list, .multiple-list {
      max-height: 250px;
    }
  }
}
</style>
